import React, { useMemo, useState } from 'react';
import { Grid, TableColumnResizing, TableHeaderRow, TableSelection } from '@devexpress/dx-react-grid-material-ui';
import {
  Column,
  DataTypeProvider,
  IntegratedSelection,
  SelectionState,
  TableColumnWidthInfo,
} from '@devexpress/dx-react-grid';
import {
  CustomFormatterWithTooltipAndComponent,
  CustomHeaderCell,
  CustomSelectionCell,
} from 'shared/components/andtComponents/TableComponents/TableComponents';
import TableWrapper from 'shared/components/tables/TableWrapper';
import { getColumns, UNASSIGNED_ACCOUNTS_COLUMNS } from '../../../consts';
import AssignTo from './AssignTo';
import RowIconNameAndText from '../../../components/LinkedAccounts/RowIconNameAndText';
import { UnassignedAccountProps } from './Interfaces';

const LinkedAccountsTable = ({ unassignedAccounts, onSelectionChange, selectedAccounts }) => {
  const [localColumnsWidth, setLocalColumnsWidth] = useState<TableColumnWidthInfo[]>(
    Object.values(UNASSIGNED_ACCOUNTS_COLUMNS).map((c) => ({
      columnName: c.columnName,
      width: c.width,
    })),
  );

  const selectedRowIndexes = useMemo(() => {
    return unassignedAccounts.reduce((acc, account, index) => {
      if (selectedAccounts.find((selected) => selected.linkedAccountId === account.linkedAccountId)) {
        acc.push(index);
      }
      return acc;
    }, []);
  }, [unassignedAccounts, selectedAccounts]);

  const handleSelectedRowsChanged = (selectedIndexes) => {
    const selected = selectedIndexes.map((index) => unassignedAccounts[index]);
    onSelectionChange(selected);
  };

  const AssignToWrapper = ({ row }: { row?: UnassignedAccountProps }) => {
    return <AssignTo selectedAccounts={row ? [row] : []} />;
  };

  const LinkedAccountNameWrapper = (props) => {
    const { row } = props;
    return (
      <CustomFormatterWithTooltipAndComponent {...props} isLeftComponent>
        <RowIconNameAndText cloudType={+row.cloudType} title="" subTitle="" isMain={false} />
      </CustomFormatterWithTooltipAndComponent>
    );
  };

  return (
    <Grid rows={unassignedAccounts} columns={getColumns(UNASSIGNED_ACCOUNTS_COLUMNS) as Column[]}>
      <SelectionState selection={selectedRowIndexes} onSelectionChange={handleSelectedRowsChanged} />
      <IntegratedSelection />
      <DataTypeProvider
        for={[UNASSIGNED_ACCOUNTS_COLUMNS.LINKED_ACCOUNT.columnName]}
        formatterComponent={LinkedAccountNameWrapper}
      />
      <DataTypeProvider for={[UNASSIGNED_ACCOUNTS_COLUMNS.ASSIGN_TO.columnName]} formatterComponent={AssignToWrapper} />
      <TableWrapper virtual height="fit-content" />
      <SelectionState selection={selectedRowIndexes} onSelectionChange={handleSelectedRowsChanged} />
      <IntegratedSelection />
      <TableColumnResizing
        resizingMode="nextColumn"
        columnWidths={localColumnsWidth}
        onColumnWidthsChange={setLocalColumnsWidth}
      />
      <TableSelection cellComponent={CustomSelectionCell} selectionColumnWidth={20} showSelectAll={true} />
      <TableHeaderRow cellComponent={CustomHeaderCell} />
    </Grid>
  );
};

export default LinkedAccountsTable;
